// import constants types
import {
    VIDFLEET_MAINTENANCE_WARNINGS_REQUEST,
    VIDFLEET_MAINTENANCE_WARNINGS_RESULT,
    VIDFLEET_MAINTENANCE_SET_LIST,
    CLEAR_REDUX,
} from "Redux/actionTypes";

// Initial state
const INIT_STATE = {
    Items: [],
    loading: false,
    hasMore: false,
    error: null,
    errorCode: null,
    list: [],
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {

        case VIDFLEET_MAINTENANCE_WARNINGS_REQUEST:
            return { ...state, loading: true };

        case VIDFLEET_MAINTENANCE_SET_LIST:
            return { ...state, list: action.payload }

        case VIDFLEET_MAINTENANCE_WARNINGS_RESULT:
            return {
                ...state,
                loading: false,
                hasMore: !action.payload.error ? action.payload.result ? action.payload.result.hasMore : false : state.hasMore,
                Items: !action.payload.error ? action.payload?.hasMore
                    ? [...state.Items, ...action.payload.result.maintenanceWarnings]
                    : action.payload.result.maintenanceWarnings : [...state.Items],
                error: action.payload.error,
                errorCode: action.payload.errorCode,
            };

        case CLEAR_REDUX:
            return ["", "MAINTENANCE_WARNING"].includes(action.payload.option)
                ? action.payload.parameters
                    ?
                    { ...state, ...action.payload.parameters }
                    :
                    { ...INIT_STATE }
                :
                { ...state }

        default:
            return state;
    }
};
